import { render, staticRenderFns } from "./RoadTax.vue?vue&type=template&id=1029871c&"
import script from "./RoadTax.vue?vue&type=script&lang=js&"
export * from "./RoadTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports